import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

// constants
import { scriptConfigViews } from 'constants/values';
import { scriptTypes } from 'constants/scripts';

// components
import ScriptConfigViewTrigger from 'triggers/ScriptConfigViewTrigger';
import ScriptConfigFertilityInputs from 'edit/ScriptConfigFertilityInputs';
import ScriptConfigPlantingInputs from 'edit/ScriptConfigPlantingInputs';
import { ScriptConfigProtectionInputs } from './ScriptConfigProtectionInputs';

const baseString = 'vra-script-config-inputs';
const classString = classNames({
  [`${baseString}`]: true
});
const ScriptConfigInputs = ({
  displayScriptName,
  hasNitrapyrin,
  maxDate,
  minDate,
  onChangeNitrapyrin,
  onChangePlantingFertilizerApplication,
  onChangeScriptName,
  onClickScriptConfigViewTrigger,
  onFertilityInputMount,
  onSelectFertilizerProduct,
  onSelectIncorporationMethodForCropProtection,
  onSelectSubstanceType,
  substanceTypeIsNitrogen,
  plantingPlanParams,
  scriptType,
  substanceTypeUuid,
  substanceTypes,
  usingLiquidIsChecked,
  validationResult
}) => {
  let content;
  switch(scriptType) {
    case scriptTypes.PLANTING:
      content = (<ScriptConfigPlantingInputs
        displayScriptName={displayScriptName}
        onChangePlantingFertilizerApplication={onChangePlantingFertilizerApplication}
        onChangeScriptName={onChangeScriptName}
        usingLiquidIsChecked={usingLiquidIsChecked}
        validationResult={validationResult}
      />);
      break;
    case scriptTypes.APPLICATION:
      content = (<ScriptConfigProtectionInputs
        displayScriptName={displayScriptName}
        maxDate={maxDate}
        minDate={minDate}
        onChangeScriptName={onChangeScriptName}
        onSelectIncorporationMethod={onSelectIncorporationMethodForCropProtection}
        plantingPlanParams={plantingPlanParams}
        validationResult={validationResult}
      />);
      break;
    case scriptTypes.FERTILITY:
    default:
      content = (<ScriptConfigFertilityInputs
        displayScriptName={displayScriptName}
        hasNitrapyrin={hasNitrapyrin}
        onChangeNitrapyrin={onChangeNitrapyrin}
        onChangeScriptName={onChangeScriptName}
        onFertilityInputMount={onFertilityInputMount}
        onSelectFertilizerProduct={onSelectFertilizerProduct}
        onSelectSubstanceType={onSelectSubstanceType}
        substanceTypeIsNitrogen={substanceTypeIsNitrogen}
        substanceTypeUuid={substanceTypeUuid}
        substanceTypes={substanceTypes}
        validationResult={validationResult}
      />);
  }

  return (
    <section className={classString}>
      <ScriptConfigViewTrigger
        currentView={scriptConfigViews.INPUTS}
        onClick={() => onClickScriptConfigViewTrigger(scriptConfigViews.SUMMARY)}
      />
      {content}
    </section>
  );
};

ScriptConfigInputs.propTypes = {
  displayScriptName: propTypes.string.isRequired,
  hasNitrapyrin: propTypes.bool.isRequired,
  maxDate: propTypes.string.isRequired,
  minDate: propTypes.string.isRequired,
  onChangeNitrapyrin: propTypes.func.isRequired,
  onChangePlantingFertilizerApplication: propTypes.func.isRequired,
  onChangeScriptName: propTypes.func.isRequired,
  onClickScriptConfigViewTrigger: propTypes.func.isRequired,
  onFertilityInputMount: propTypes.func.isRequired,
  onSelectFertilizerProduct: propTypes.func.isRequired,
  onSelectIncorporationMethodForCropProtection: propTypes.func.isRequired,
  onSelectSubstanceType: propTypes.func.isRequired,
  plantingPlanParams: propTypes.object.isRequired,
  scriptType: propTypes.string.isRequired,
  substanceTypeIsNitrogen: propTypes.bool.isRequired,
  substanceTypeUuid: propTypes.string, // Null is a valid value to pass indicating no incorporation method, so can't use .isRequired here.
  substanceTypes: propTypes.object.isRequired,
  usingLiquidIsChecked: propTypes.bool.isRequired,
  validationResult: propTypes.object
};
export default ScriptConfigInputs;
